import { render, staticRenderFns } from "./PageDeGardeRecap.vue?vue&type=template&id=4a45d956"
import script from "./PageDeGardeRecap.vue?vue&type=script&lang=js"
export * from "./PageDeGardeRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports